import { render, staticRenderFns } from "./supervisorTheAssessmentOK.vue?vue&type=template&id=086b8efa&scoped=true&"
import script from "./supervisorTheAssessmentOK.vue?vue&type=script&lang=js&"
export * from "./supervisorTheAssessmentOK.vue?vue&type=script&lang=js&"
import style0 from "./supervisorTheAssessmentOK.vue?vue&type=style&index=0&id=086b8efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b8efa",
  null
  
)

export default component.exports